import React from "react";
import { useSelector } from "react-redux";
import { TableLoader } from "../../components/tableLoader";
import { TableModel } from "../../../personal-studio-components/table/TableModel";

function OnlineLibs() {
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const loader = {
    title: "Электронные библиотечные системы",
    icon: "book_open",
    request: {
      method: "post",
      path: "/resources/online_libs",
      data: {
        access_token,
        study_contract_id: contractId,
      },
    },
    parser: createModel,
  };
  function createModel(response) {
    const rows = [...response];
    const columns = [{ field: "", type: "link", icon: "copy" }];
    const table = new TableModel({ rows, columns });
    table.rows = table.rows.filter((row) => row.label);
    table.rows = table.rows.map((row) => ({
      "": {
        name: row.label,
        href: row.url,
        icon: "copy",
        target: "blank",
      },
    }));
    return table;
  }
  return <TableLoader {...loader} />;
}

export default OnlineLibs;
